import md5 from "md5";

export class OrgUsersTab extends HTMLElement {
  private _members: any[] = [];
  private _invites: any[] = [];
  private _showInviteModal: boolean = false;

  set members(val: any[]) {
    this._members = val;
    this.render();
  }

  set invites(val: any[]) {
    this._invites = val;
    this.render();
  }

  public getRoleChanges() {
    const changes: { userId: string, role: string }[] = [];
    console.log(`[OrgUsersTab] getRoleChanges, current members:`, JSON.stringify(this._members));
    this.querySelectorAll('.role-select').forEach((select: any) => {
      const userId = select.dataset.userId;
      const newRole = select.value;
      const originalMember = this._members.find(m => m.user_id === userId);
      
      console.log(`[OrgUsersTab] Checking member ${userId}: original=${originalMember?.user_role}, new=${newRole}`);
      if (originalMember && originalMember.user_role !== newRole) {
        console.log(`[OrgUsersTab] Member ${userId} role changed!`);
        changes.push({ userId, role: newRole });
      }
    });
    return changes;
  }

  private _renderTimeout: any = null;

  private render() {
    if (this._renderTimeout) return;
    this._renderTimeout = setTimeout(() => {
        this._renderInternal();
        this._renderTimeout = null;
    }, 0);
  }

  private _renderInternal() {
    if (!this.querySelector('.main-users-container')) {
        this.innerHTML = `
            <div class="main-users-container"></div>
            <div class="modal-container"></div>
        `;
    }

    const mainContainer = this.querySelector('.main-users-container')!;
    const modalContainer = this.querySelector('.modal-container')!;

    mainContainer.innerHTML = `
      <style>
        .users-table {
          width: 100%;
          border-collapse: separate;
          border-spacing: 0 8px;
          font-family: var(--font-mono);
        }
        .users-table th {
          text-align: left;
          padding: 12px;
          color: var(--text-dim);
          font-size: 0.75rem;
          text-transform: uppercase;
        }
        .users-table td {
          padding: 16px 12px;
          background: rgba(255,255,255,0.03);
          border-top: 1px solid var(--border-sketch);
          border-bottom: 1px solid var(--border-sketch);
        }
        .users-table td:first-child {
          border-left: 1px solid var(--border-sketch);
          border-radius: 4px 0 0 4px;
        }
        .users-table td:last-child {
          border-right: 1px solid var(--border-sketch);
          border-radius: 0 4px 4px 0;
        }
        .role-select {
          appearance: none;
          background: rgba(255,255,255,0.03);
          border: 1px solid var(--border-sketch);
          color: var(--text-main);
          padding: 6px 32px 6px 12px;
          border-radius: 4px;
          font-family: var(--font-mono);
          font-size: 0.8rem;
          cursor: pointer;
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%23f59e0b'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M19 9l-7 7-7-7'%3E%3C/path%3E%3C/svg%3E");
          background-repeat: no-repeat;
          background-position: right 8px center;
          background-size: 14px;
          transition: all 0.2s ease;
        }
        .role-select:hover {
          border-color: var(--accent);
          background-color: rgba(255,255,255,0.06);
        }
        .role-select:focus {
          outline: none;
          border-color: var(--accent);
          box-shadow: 0 0 0 2px rgba(245, 158, 11, 0.1);
        }
        .role-select option {
          background: #1a1a1a;
          color: white;
        }
        .status-badge {
          padding: 4px 8px;
          border-radius: 4px;
          font-size: 0.7rem;
          text-transform: uppercase;
        }
        .status-pending { background: rgba(255, 165, 0, 0.1); color: orange; border: 1px solid orange; }
        .status-active { background: rgba(0, 255, 0, 0.1); color: #00ff00; border: 1px solid #00ff00; }
      </style>

      <div style="display: flex; flex-direction: column; gap: 32px;">
        <div style="display: flex; justify-content: flex-end;">
          <app-button id="open-invite-modal-btn" icon="plus" size="sm" variant="white" square data-tooltip="Invite Member">
          </app-button>
        </div>

        <div class="sketchy-card">
          <table class="users-table">
            <thead>
              <tr>
                <th>Member</th>
                <th>Role</th>
                <th>Joined</th>
                <th style="width: 50px;"></th>
              </tr>
            </thead>
            <tbody>
              ${this._members.map(member => `
                <tr>
                  <td>
                    <div style="display: flex; align-items: center; gap: 12px;">
                      <div style="width: 32px; height: 32px; border-radius: 4px; overflow: hidden; display: flex; align-items: center; justify-content: center; border: 1px solid var(--border-sketch);">
                        <img src="https://www.gravatar.com/avatar/${md5(member.email.trim().toLowerCase())}?d=identicon" style="width: 100%; height: 100%; object-fit: cover;">
                      </div>
                      <div>
                        <div style="color: var(--text-main); font-weight: bold; font-family: var(--font-mono);">${member.email}</div>
                      </div>
                    </div>
                  </td>
                  <td>
                    <select class="role-select" data-user-id="${member.user_id}">
                      <option value="admin" ${member.user_role === 'admin' ? 'selected' : ''}>Admin</option>
                      <option value="member" ${member.user_role === 'member' ? 'selected' : ''}>Member</option>
                      <option value="viewer" ${member.user_role === 'viewer' ? 'selected' : ''}>Viewer</option>
                    </select>
                  </td>
                  <td style="color: var(--text-dim); font-size: 0.9rem;">
                    ${new Date(member.created_at).toLocaleDateString()}
                  </td>
                  <td>
                    <app-button variant="ghost" size="sm" class="remove-member-btn" data-id="${member.user_id}" icon="trash" data-tooltip="Remove Member">
                    </app-button>
                  </td>
                </tr>
              `).join('')}
            </tbody>
          </table>
        </div>

        ${this._invites.length > 0 ? `
          <div style="margin-top: 24px;">
            <h4 style="font-family: var(--font-sketch); color: var(--text-dim); margin-bottom: 16px;">Pending Invites</h4>
            <div class="sketchy-card">
              <table class="users-table">
                <thead>
                  <tr>
                    <th>Email</th>
                    <th>Role</th>
                    <th>Sent</th>
                    <th style="width: 50px;"></th>
                  </tr>
                </thead>
                <tbody>
                  ${this._invites.map(invite => `
                    <tr>
                      <td style="color: var(--text-main); font-family: var(--font-mono);">${invite.email}</td>
                      <td><span class="status-badge status-pending">${invite.role}</span></td>
                      <td style="color: var(--text-dim); font-size: 0.9rem;">
                        ${new Date(invite.created_at).toLocaleDateString()}
                      </td>
                      <td>
                        <app-button variant="ghost" size="sm" class="revoke-invite-btn" data-id="${invite.id}" icon="x" data-tooltip="Revoke Invite">
                        </app-button>
                      </td>
                    </tr>
                  `).join('')}
                </tbody>
              </table>
            </div>
          </div>
        ` : ''}
      </div>
    `;

    if (this._showInviteModal) {
      modalContainer.innerHTML = `
        <app-modal id="invite-modal" open>
          <div slot="header">Invite New Member</div>
          <div style="padding: 20px;">
            <div style="margin-bottom: 24px;">
              <label style="display: block; margin-bottom: 8px; font-size: 0.75rem; color: var(--text-dim); font-family: var(--font-mono);">EMAIL ADDRESS</label>
              <input type="email" id="invite-email" placeholder="colleague@company.com" 
                     style="width: 100%; padding: 12px; background: rgba(255,255,255,0.03); border: 1px solid var(--border-sketch); color: white; border-radius: 4px; font-family: var(--font-mono);">
            </div>
            <div>
              <label style="display: block; margin-bottom: 8px; font-size: 0.75rem; color: var(--text-dim); font-family: var(--font-mono);">ASSIGN ROLE</label>
              <select id="invite-role" class="role-select" style="width: 100%;">
                <option value="member">Member</option>
                <option value="admin">Admin</option>
                <option value="viewer">Viewer</option>
              </select>
            </div>
          </div>
          <div slot="actions">
            <app-button variant="ghost" size="sm" id="cancel-invite-btn" icon="x" data-tooltip="Cancel"></app-button>
            <app-button variant="primary" size="sm" id="send-invite-btn" icon="send" data-tooltip="Send Invitation"></app-button>
          </div>
        </app-modal>
      `;
    } else {
      modalContainer.innerHTML = '';
    }

    this.setupListeners();
  }

  private _initialized: boolean = false;

  private initEvents() {
    if (this._initialized) return;
    this._initialized = true;

    this.addEventListener('click', (e: any) => {
      const target = e.target as HTMLElement;
      if (target.classList.contains('remove-member-btn')) {
        const userId = target.dataset.id;
        this.dispatchEvent(new CustomEvent('remove-member', {
          detail: { userId },
          bubbles: true,
          composed: true
        }));
      } else if (target.classList.contains('revoke-invite-btn')) {
        const inviteId = target.dataset.id;
        this.dispatchEvent(new CustomEvent('revoke-invite', {
          detail: { inviteId },
          bubbles: true,
          composed: true
        }));
      } else if (target.id === 'open-invite-modal-btn') {
        this._showInviteModal = true;
        this.render();
      } else if (target.id === 'cancel-invite-btn') {
        this._showInviteModal = false;
        this.render();
      } else if (target.id === 'send-invite-btn') {
        const email = (this.querySelector('#invite-email') as HTMLInputElement)?.value;
        const role = (this.querySelector('#invite-role') as HTMLSelectElement)?.value;
        if (email) {
          this.dispatchEvent(new CustomEvent('invite-member', {
            detail: { email, role },
            bubbles: true,
            composed: true
          }));
          this._showInviteModal = false;
          this.render();
        }
      }
    });

    this.addEventListener('change', (e: any) => {
        if (e.target.classList.contains('role-select')) {
            const userId = (e.target as HTMLElement).dataset.userId;
            const role = (e.target as HTMLSelectElement).value;
            this.dispatchEvent(new CustomEvent('update-role', {
                detail: { userId, role },
                bubbles: true,
                composed: true
            }));
        }
    });
  }

  private setupListeners() {
    // Keep this for DOM-specific bindings if any (e.g. modal specific close)
    const modal = this.querySelector('#invite-modal');
    if (modal) {
      modal.addEventListener('change', (e) => e.stopPropagation());
      modal.addEventListener('close', () => {
        this._showInviteModal = false;
      });
    }
  }

  connectedCallback() {
    this.initEvents();
    this.render();
  }
}

if (!customElements.get('org-users-tab')) {
  customElements.define('org-users-tab', OrgUsersTab);
}
